module.exports = __webpack_public_path__ + "static/img/slide_4_fr.e27bfda.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/live-hr-advice/slider/slide_4_fr.png
// module id = 2E/4
// module chunks = 0